module.exports = __webpack_public_path__ + "static/img/banner_img3.cfa7f13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_img3.png
// module id = Y7rN
// module chunks = 0